export const scopeAddProperties = (scope: string) => scope.replaceAll('/', '/properties/')

export const scopePartToPath = (scope: string) => scope.replaceAll('/', '.')

export const scopeWithoutRepeat = (scope: string) => scope.replace(/\/\d+\//g, '/').replace(/\/\d+$/, '')

export const scopeFullToPath = (scope: string = '') => scope.replaceAll('#/', '').replaceAll('/', '.')

export const scopeAddRepeat = (scope: string, arrayScope: string, index: number) =>
  scope.replace(arrayScope, arrayScope + '/' + index)

export const pathToScope = (path: string) => '#/' + path.replaceAll('.', '/')
